import lazyLoading from './lazyLoading'

export default {
  name: 'Users',
  path: '/users',
  meta: {
    auth: true,
    icon: 'fa-users',
    link: 'users/index.vue'
  },
  component: lazyLoading('users', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/users.js